import React, { useEffect, useState } from "react"
import {
  View,
  Text,
  Image,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
  Platform,
  Linking,
  ActivityIndicator,
} from "react-native"
import AsyncStorage from "@react-native-async-storage/async-storage"
import axios from "axios"
import API_PATHS from '../src/apiCalls/ApiPath'
const ViewInvoice = ({ route, navigation }) => {
  const invoiceId = route.params?.invoiceId;
  const type = route.params?.type;
  const [pdfUrl, setPdfUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  if (type == 2) {
    console.log("This is an other booking")
  } else {
    console.log("This is a booking")
  }



  useEffect(() => {
    const fetchInvoice = async () => {
      const token = await AsyncStorage.getItem("token")
      if (!token) {
        return
      }
      if (!invoiceId) {
        setError("Invoice ID is missing")
        setLoading(false)
        return
      }

      try {
        const response = await axios.get(`${API_PATHS.BASE_URL}${API_PATHS.GET_INVOICE}/${invoiceId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        })
        const pdfBlob = new Blob([response.data], { type: "application/pdf" })
        const pdfUrl = URL.createObjectURL(pdfBlob)
        setPdfUrl(pdfUrl)
        setLoading(false)
      } catch (error) {
        setError("Failed to fetch invoice. Please try again later.")
        setLoading(false)
      }
    }
    fetchInvoice()
  }, [invoiceId, type])

  const handleViewDownload = () => {
    if (pdfUrl) {
      if (Platform.OS === "web") {
        window.open(pdfUrl, "_blank")
      } else {
        Linking.openURL(pdfUrl)
      }
    }
  }

  const handleBackPress = () => {
    navigation.goBack()
  }

  if (loading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#A6CE39" />
      </View>
    )
  }

  if (error) {
    return (
      <View style={styles.centered}>
        <Text style={styles.errorText}>{error}</Text>
      </View>
    )
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={handleBackPress} style={styles.backButton}>
          <Image source={require("./assets/back1.png")} style={styles.backIcon} />
        </TouchableOpacity>
        <Text style={styles.headerText}>Invoice Id - #{invoiceId}</Text>
      </View>
      <View style={styles.content}>
        <Text style={styles.infoText}>Your invoice is ready. Click the button below to view or download it.</Text>
        <TouchableOpacity style={styles.button} onPress={handleViewDownload}>
          <Text style={styles.buttonText}>View/Download Invoice</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    backgroundColor: "#A6CE39",
    padding: 15,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
  },
  headerText: {
    fontSize: 30,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: "#fff",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  infoText: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    textAlign: "center",
    marginBottom: 20,
  },
  button: {
    backgroundColor: "#A6CE39",
    padding: 15,
    borderRadius: 5,
  },
  buttonText: {
    color: "#fff",
    fontSize: 18,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: 'normal',
    fontWeight: "bold",
  },
  centered: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  errorText: {
    color: "red",
    fontSize: 16,
    textAlign: "center",
  },
  backButton: {
    position: "absolute",
    left: 20,
    top: 18,
  },
  backIcon: {
    width: 12,
    height: 24,
  },
})

export default ViewInvoice

